// OrdenServicioTrasladoPage.tsx

import { PermissionsEnum, SystemModulesEnum } from "@/auth/interfaces";
import { hasPermission, hasSystemModule, sizeTab, a11yProps, EstadosPreagendamientoEnumChoice } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { TableOrdenServicioTraslado } from "../../components";
import TrasladosFinalizadosTab from "../../components/traslados-finalizados/TrasladosFinalizadosTab";

export default function OrdenServicioTrasladoPage() {

  hasPermission(PermissionsEnum.api_view_ordenserviciotraslado)

  const [valueTab, setValueTab] = useState(0);

  // Tab "Finalizados" gateado por módulo de sistema (activable desde
  // Gestión de Accesos > Módulos del Sistema).
  const showFinalizados = hasSystemModule(SystemModulesEnum.OPERACIONES_TRASLADOS_FINALIZADOS);


  return (
    <>
      <SingleTableBoxScene title={"Traslado"}
        py={2}
        visibleReport={false}
      >
        <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 3 }} >
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs ordenserviciotraslado"
          >
            <Tab label={'En Espera'} {...a11yProps(0)} />
            <Tab label={'Agendandado'} {...a11yProps(1)} />
            <Tab label={'Recoordinado'} {...a11yProps(2)} />
            {showFinalizados && <Tab label={'Finalizados'} {...a11yProps(3)} />}
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <TableOrdenServicioTraslado estadoAgendamiento={`${EstadosPreagendamientoEnumChoice.EN_ESPERA},${EstadosPreagendamientoEnumChoice.EN_PAUSA}`} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <TableOrdenServicioTraslado estadoAgendamiento={EstadosPreagendamientoEnumChoice.FINALIZADO} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <TableOrdenServicioTraslado estadoAgendamiento={EstadosPreagendamientoEnumChoice.RECORDINADO} />
        </CustomTabPanel>
        {showFinalizados && (
          <CustomTabPanel value={valueTab} index={3}>
            <TrasladosFinalizadosTab />
          </CustomTabPanel>
        )}
      </SingleTableBoxScene >

      
    </>
  )
}